import {
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { FtiDetailsCard } from "./FtiDetailsCard";

const headerCellSx = { bgcolor: "#F5F5F5", fontWeight: 600, py: "10px" };

// `payment` is the details API's payment summary: its payments, status and the change returned
export const FtiPaymentMedia = ({ payment, formatAmount }) => {
  const { payments = [], payment_status, change_returned = 0 } = payment ?? {};
  const isPaid = payment_status?.toLowerCase() === "completed";

  return (
    <FtiDetailsCard
      title="Payment Media/ช่องทางชำระเงิน"
      rightContent={
        isPaid && (
          <Stack direction="row" alignItems="center" gap="8px">
            <Typography variant="body2" fontWeight={500}>
              Paid/ชำระแล้ว
            </Typography>
            <CheckCircleIcon color="success" sx={{ fontSize: 20 }} />
          </Stack>
        )
      }
    >
      <TableContainer>
        <Table sx={{ minWidth: 600 }}>
          <TableHead>
            <TableRow>
              <TableCell sx={headerCellSx}>Type/ประเภท</TableCell>
              <TableCell sx={headerCellSx}>Amount/จำนวนเงิน</TableCell>
              <TableCell sx={headerCellSx}>Cash Tendered/เงินสดที่รับ</TableCell>
              <TableCell sx={headerCellSx}>Change Given/เงินทอนที่จ่าย</TableCell>
              <TableCell sx={headerCellSx} align="right">
                Txn Date/วันที่ทำรายการ
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {payments.length > 0 ? (
              payments.map((item, index) => {
                // Same as the sales log: tendered and change only apply to cash payments
                const isCash = item.type === "Cash";
                const amount = (Number(item.amount) || 0) / 100;

                return (
                  <TableRow key={item.id ?? index}>
                    <TableCell>{item.type}</TableCell>
                    <TableCell>{formatAmount(amount)}</TableCell>
                    <TableCell>
                      {isCash
                        ? formatAmount(amount + change_returned)
                        : "--"}
                    </TableCell>
                    <TableCell>
                      {isCash ? formatAmount(change_returned) : "--"}
                    </TableCell>
                    <TableCell align="right">{item.display_txn_date ?? "--"}</TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  <Typography variant="body2" color="GrayText">
                    No payments found
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </FtiDetailsCard>
  );
};
